import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as userDataActions from '../../../actions/userDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as resourceActions from '../../../actions/resourcesActions';
import {RESOURCE_PROPS} from '../../../models/appModels';
import * as appHelper from '../../../helpers/appHelper';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as objectConstants from '../../../constants/objectConstants';
import * as actionTypes from '../../../actions/actionTypes';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class ResourceScreenLink extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            resource: this.props.resource,
            userData: this.props.userData,
            activeResourcesId: this.props.activeResourcesId,
            locale: appHelper.getLocalData(this.props.resource),
            showResources: false,
            checkCompletion: false,
            required_label: appHelper.getLocaleString("required_label")
        };
        this.onOpen = this.onOpen.bind(this);
        this.getStatusClass = this.getStatusClass.bind(this);
        this.setActiveResourceId = this.setActiveResourceId.bind(this);
        this.openResources = this.openResources.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);

    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {
        if(this.state.userData !== nextProps.userData){
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if(this.state.activeResourcesId !== nextProps.activeResourcesId){
            this.setState({activeResourcesId: nextProps.activeResourcesId, showResources: true});
        }

        if(this.state.lang !== nextProps.lang){
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.resource),
                required_label: appHelper.getLocaleString("required_label")
            });
        }
    }

    componentDidUpdate() {
        if (this.state.showResources) {
            this.openResources();
        }
    }

    getStatusClass(){
        let screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.resource.screen_id);

        if (screenUserData.status === objectConstants.STATUS_NOT_STARTED) {
            return "not-started";
        } else if (screenUserData.status === objectConstants.STATUS_IN_PROGRESS) {
            return "in-progress";
        } else if (screenUserData.status === objectConstants.STATUS_COMPLETE) {
            return "complete";
        }

        return "disabled";
    }

    onOpen(){
        let screenUserData = userDataHelper.getResourceScreenUserData(this.state.userData, this.state.resource.screen_id);
        if(appHelper.isDefined(screenUserData.status)) {
           this.setActiveResourceId();
        }
    }

    setActiveResourceId() {
        let resourceProps = Object.assign({}, RESOURCE_PROPS, {
			activeResourcesId: this.state.resource.screen_id,
            sourceId: `resource_link_${this.state.resource.screen_id}`
        });
        this.props.actions.setResourcesProps(resourceProps);
    }

    openResources(){
        this.setState({showResources: false});
        if (this.state.activeResourcesId != "") {
            this.props.actions.setResourcesDisplay(actionTypes.STATUS_OPENING);
        }
    }

    setKeyboardAccessibility(event) {
        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.preventDefault();
            this.onOpen();
        }
    }

    render() {
        return (
            <li className={`resource-link ${this.getStatusClass()}`}>
                <span className="resources" onClick={this.onOpen} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex="0" id={`resource_link_${this.state.resource.screen_id}`} dangerouslySetInnerHTML={{__html: this.state.locale.label}} />
                {this.state.resource.required
                    ?
                    <span className="required-label"> - {this.state.required_label}</span>
                    :
                    null
                }
            </li>
        );
    }
}

ResourceScreenLink.propTypes = {
    resource: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    userData: PropTypes.object.isRequired,
    displayResources: PropTypes.string.isRequired,
    activeResourcesId: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object.isRequired
};

ResourceScreenLink.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang:lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
        displayResources: state.displayResources,
        activeResourcesId: state.resourceProps.activeResourcesId,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, userDataActions, trackingDataActions, resourceActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceScreenLink);



/** WEBPACK FOOTER **
 ** ./src/components/objects/resourceLinks/ResourceScreenLink.js
 **/